import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProgressProvider from './_components/progress-provider';
import { ThemeProvider } from './_components/theme-provider';
import { AuthProvider } from './_contexts/auth-context';
import { TenantProvider, getCurrentTenant } from './_contexts/tenant-context';
import {
  AuthRoutes,
  DashboardRoutes,
  StudioRoutes,
  NanoBananaRoutes,
} from './_routes';
import DashboardRedirect from './dashboard/_components/dashboard-redirect';
import { Toaster } from './_components/ui/toaster';
import { PageLoading } from './_components/page-loading';

function MainAppRoutes() {
  return (
    <AuthProvider>
      <ProgressProvider>
        <Suspense fallback={<PageLoading />}>
          <Routes>
            <Route path="/" element={<Navigate to="/auth/login" replace />} />
            {AuthRoutes}
            <Route path="/dashboard" element={<DashboardRedirect />} />
            {DashboardRoutes}
            {StudioRoutes}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <Toaster />
      </ProgressProvider>
    </AuthProvider>
  );
}

function NanoBananaApp() {
  return (
    <ProgressProvider>
      <Suspense fallback={<PageLoading />}>
        <Routes>
          {NanoBananaRoutes}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <Toaster />
    </ProgressProvider>
  );
}

function App() {
  const tenant = getCurrentTenant();

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <TenantProvider>
        {tenant === 'nanobanana' ? <NanoBananaApp /> : <MainAppRoutes />}
      </TenantProvider>
    </ThemeProvider>
  );
}

export default App;
